import { render } from "./FontSpecimenVariableBlock.vue?vue&type=template&id=b00f7b8c"
import script from "./FontSpecimenVariableBlock.vue?vue&type=script&lang=js"
export * from "./FontSpecimenVariableBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/FontSpecimenVariableBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b00f7b8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b00f7b8c', __exports__)) {
    api.reload('b00f7b8c', __exports__)
  }
  
  module.hot.accept("./FontSpecimenVariableBlock.vue?vue&type=template&id=b00f7b8c", () => {
    api.rerender('b00f7b8c', render)
  })

}


export default __exports__